import { render, staticRenderFns } from "./FooterWeather.vue?vue&type=template&id=4fc1fcaa&scoped=true"
import script from "./FooterWeather.vue?vue&type=script&lang=js"
export * from "./FooterWeather.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc1fcaa",
  null
  
)

export default component.exports